const myInformation = {
    heroSection: {
        myName: {
            firstName: "Umair",
            lastName: "Shoukat",
        },
        iAmAWhat: ["Software Developer", "Mobile App Developer"],
        socialLinks: {
            instaLink: "",
            githubLink: "https://github.com/",
            fbLink: "",
            linkedinLink: "https://www.linkedin.com/",
        },
    },
    educationSection: {
         
        WhatStudy: " Masters University of West Scotland, London Campus ",
        myeducationDetails: " Present Course MSC information technology Bacholer Comsats institute of information technology 03/2018 - 01/2022, Abbottabad",
        myStudyinfo: "Bachelor in software engineering",
    },
    aboutSection: {
        aboutMeTitle: "I am an adventurous mobile app developer, eager to explore diverse technology stacks",
        iAmWhat: "Umair Shoukat",
        aboutMeDescription:
            "from 60 Charter Ave, Ilford, London, England. I am a passionate mobile app developer who is eager to explore every technology stack out there. I am constantly seeking new challenges and opportunities to expand my skills and knowledge. With my strong technical background and creative mindset, I am confident in my ability to deliver exceptional mobile applications that meet the needs and expectations of my clients. Let's work together to bring your ideas to life!"
        },
      contactSection: {
        web3FormsEndpoint: "https://api.web3forms.com/submit",
        web3FormsAccessKey: "b5d25ff6-33a1-4193-b520-b94354014d62"
    },
};

export default myInformation;
